// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.flex-container {
    display: flex;
    gap: 10px;
    margin-top: 10px;
    margin-bottom: 30px;
}

.metric-select {
    flex: 0 0 40%;
    margin-right: 150px;
}

.date-select {
    flex: 0 0 25%;
}
.labelGraficKpi{
    color: var(--third-color) !important;
    font-size: var(--font-size-med) !important;
    left: 10% !important;
position: relative !important;
}
.contGrafKapi{
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.selectGraficKpi{
 background-color: var(--white-color) !important;
 color: var(--txt-color) !important;
 border-color: var(--border-table-color) !important;
width: 70% !important;
left: 10% !important;
position: relative !important;
}
.inputGraficKpi{
    width: 70% !important;
  /* padding: 10px 0; */
  position: relative !important;
  left: 10% !important;
  font-size: var(--font-size-small);
  color: var(--txt-color);
  /* margin-bottom: 30px; */
  border: 2px solid var(--border-table-color);
  border-radius: 4px;
  outline: none;
  background: transparent;
  height: 20%;
}
.reporte-kpis-container{
    /* border: 1px solid var(--border-table-color);
    border-radius: var(--border-radios-small); */
}
.contSearcgGraficKpi{
    width: 100%;
     border: 1px solid var(--border-table-color);
    border-radius: var(--border-radios-small);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    position: relative;
  margin-bottom: 2%;
}
.butonGraficKpi{
    position: relative;
  left: 15%;
  /* float: right; */
  background-color: var(--second-color);
  color: white;
  border: none;
  /* padding: 5px 10px; */
  cursor: pointer;
  font-size: var(--font-size-med);
  border-radius: 4px;
  
}
 /* **************************** horizontal Movil****************************** */
 @media (min-width: 500px) and(max-width: 900px) {
 
 }
   /* ****************************Movil****************************** */
 @media (max-width: 500px) {
    .contgrafMovil{
        min-width: 250px;
    }
 }
 `, "",{"version":3,"sources":["webpack://./src/components/reportes-components/Reportes/ReporteKpis.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,oBAAoB;AACxB,6BAA6B;AAC7B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;CACC,+CAA+C;CAC/C,kCAAkC;CAClC,kDAAkD;AACnD,qBAAqB;AACrB,oBAAoB;AACpB,6BAA6B;AAC7B;AACA;IACI,qBAAqB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;IACI;gDAC4C;AAChD;AACA;IACI,WAAW;KACV,2CAA2C;IAC5C,yCAAyC;IACzC,wCAAwC;IACxC,kBAAkB;EACpB,iBAAiB;AACnB;AACA;IACI,kBAAkB;EACpB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;;AAEpB;CACC,gFAAgF;CAChF;;CAEA;GACE,oEAAoE;CACtE;IACG;QACI,gBAAgB;IACpB;CACH","sourcesContent":["\r\n.flex-container {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-top: 10px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.metric-select {\r\n    flex: 0 0 40%;\r\n    margin-right: 150px;\r\n}\r\n\r\n.date-select {\r\n    flex: 0 0 25%;\r\n}\r\n.labelGraficKpi{\r\n    color: var(--third-color) !important;\r\n    font-size: var(--font-size-med) !important;\r\n    left: 10% !important;\r\nposition: relative !important;\r\n}\r\n.contGrafKapi{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.selectGraficKpi{\r\n background-color: var(--white-color) !important;\r\n color: var(--txt-color) !important;\r\n border-color: var(--border-table-color) !important;\r\nwidth: 70% !important;\r\nleft: 10% !important;\r\nposition: relative !important;\r\n}\r\n.inputGraficKpi{\r\n    width: 70% !important;\r\n  /* padding: 10px 0; */\r\n  position: relative !important;\r\n  left: 10% !important;\r\n  font-size: var(--font-size-small);\r\n  color: var(--txt-color);\r\n  /* margin-bottom: 30px; */\r\n  border: 2px solid var(--border-table-color);\r\n  border-radius: 4px;\r\n  outline: none;\r\n  background: transparent;\r\n  height: 20%;\r\n}\r\n.reporte-kpis-container{\r\n    /* border: 1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-small); */\r\n}\r\n.contSearcgGraficKpi{\r\n    width: 100%;\r\n     border: 1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-small);\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    position: relative;\r\n  margin-bottom: 2%;\r\n}\r\n.butonGraficKpi{\r\n    position: relative;\r\n  left: 15%;\r\n  /* float: right; */\r\n  background-color: var(--second-color);\r\n  color: white;\r\n  border: none;\r\n  /* padding: 5px 10px; */\r\n  cursor: pointer;\r\n  font-size: var(--font-size-med);\r\n  border-radius: 4px;\r\n  \r\n}\r\n /* **************************** horizontal Movil****************************** */\r\n @media (min-width: 500px) and(max-width: 900px) {\r\n \r\n }\r\n   /* ****************************Movil****************************** */\r\n @media (max-width: 500px) {\r\n    .contgrafMovil{\r\n        min-width: 250px;\r\n    }\r\n }\r\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
